import { MenuProps } from 'components/Menu/Types'
import { Menu } from 'components/Menu/Menu'
import { Item, Section } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { ALIGNMENT } from 'prose-core'
import { changeAlignment } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'

export const AlignmentSubMenu = observer(
  ({ onAction, menuType = 'dropdown' }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
    const view = useEditorView()
    const editorState = useAlmanacEditorState()
    const { activeAlignments } = editorState || {
      activeAlignments: new Set<ALIGNMENT>(),
    }

    const handleAction = (action: Key) => {
      onAction?.(action)
      return changeAlignment(view, action as ALIGNMENT)()
    }

    return (
      <Menu
        onAction={handleAction}
        menuType={menuType}
        selectedKeys={activeAlignments}
        selectionMode="multiple"
        aria-label="Alignment"
      >
        <Section>
          <Item key={ALIGNMENT.Left}>Left</Item>
          <Item key={ALIGNMENT.Center}>Center</Item>
          <Item key={ALIGNMENT.Right}>Right</Item>
          <Item key={ALIGNMENT.Justify}>Justified</Item>
        </Section>
      </Menu>
    )
  },
)
